import React from 'react';

interface KpiCardProps {
  label: string;
  value: string;
  subValue?: string;
  icon: React.ReactNode;
  trend?: { value: string; positive: boolean };
  accentColor?: 'purple' | 'pink' | 'green' | 'amber' | 'red' | 'cyan';
  className?: string;
}

const accentMap = {
  purple: 'bg-secondary text-primary',
  pink: 'bg-pink-50 text-accent',
  green: 'bg-[var(--status-green-bg)] text-[var(--status-green)]',
  amber: 'bg-[var(--status-yellow-bg)] text-[var(--status-yellow)]',
  red: 'bg-[var(--status-red-bg)] text-[var(--status-red)]',
  cyan: 'bg-cyan-50 text-cyan-600',
};

export default function KpiCard({
  label,
  value,
  subValue,
  icon,
  trend,
  accentColor = 'purple',
  className = '',
}: KpiCardProps) {
  return (
    <div className={`card-base card-hover p-5 flex flex-col gap-3 ${className}`}>
      <div className="flex items-start justify-between">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${accentMap[accentColor]}`}>
          {icon}
        </div>
        {trend && (
          <span
            className={`text-xs font-600 px-2 py-1 rounded-full ${
              trend.positive
                ? 'bg-[var(--status-green-bg)] text-[var(--status-green)]'
                : 'bg-[var(--status-red-bg)] text-[var(--status-red)]'
            }`}
          >
            {trend.positive ? '↑' : '↓'} {trend.value}
          </span>
        )}
      </div>
      <div>
        <p className="stat-label mb-1">{label}</p>
        <p className="stat-value font-tabular">{value}</p>
        {subValue && <p className="text-xs text-muted-foreground mt-0.5">{subValue}</p>}
      </div>
    </div>
  );
}